import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PropertyOwnershipActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Property/PropertyOwnership/PropertyOwnershipBrowser")
	}

	render() {
		return (
			<Activity 
				name="PropertyOwnership"
				RenderedComponent={this.RenderedComponent}
				context="PropertyOwnership"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PropertyOwnershipActivity)
